import type { SiteContent } from '@saas-bot/types';

/**
 * Rendered only if the API is fully unreachable. The server already falls back
 * to rich defaults, so this just keeps the site presentable during an outage.
 */
export const FALLBACK_CONTENT: SiteContent = {
  settings: {
    brandName: 'Vaanexa',
    logoUrl: '/icons/vaanexa-icon-light.svg',
    // Kept for schema compatibility only — the site renders on a fixed dark
    // palette and no longer applies these (see applyTheme in main.tsx).
    accentColor: '#b79bff',
    backgroundColor: '#05060d',
    nav: [
      { label: 'Product', href: '/features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
    primaryCta: { label: 'Open app', href: 'https://app.vaanexa.com' },
    secondaryCta: { label: 'Book demo', href: '/contact' },
    footer: {
      tagline: 'One AI control room for every conversation that sells.',
      columns: [],
      socials: [],
      legalLine: `© ${new Date().getFullYear()} Vaanexa. All rights reserved.`,
    },
    seo: {
      defaultTitle: 'Vaanexa — AI sales automation for conversations',
      defaultDescription:
        'Vaanexa turns WhatsApp and Instagram chats into qualified leads, bookings and revenue.',
    },
    updatedAt: null,
  },
  pages: [
    {
      id: 'home',
      slug: 'home',
      title: 'Home',
      navLabel: 'Home',
      showInNav: false,
      navOrder: 0,
      status: 'PUBLISHED',
      scheduledPublishAt: null,
      publishedAt: null,
      reviewNote: null,
      hasDraftChanges: false,
      seoTitle: null,
      seoDescription: null,
      canonicalUrl: null,
      ogTitle: null,
      ogDescription: null,
      seoImageUrl: null,
      noindex: false,
      updatedAt: null,
      blocks: [
        {
          id: 'hero',
          type: 'hero',
          eyebrow: 'AI-Powered Conversational Commerce',
          headline: 'Turn every conversation into a customer.',
          subheadline:
            'Vaanexa helps businesses manage WhatsApp, Instagram and Messenger conversations, qualify leads, automate follow-ups and move customers from their first message to final conversion.',
          primaryCta: { label: 'Start Free', href: '/signup' },
          secondaryCta: { label: 'Book a Demo', href: '/demo' },
          imageUrl: '/icons/vaanexa-icon.svg',
          sceneId: 'conversation_core',
        },
        {
          id: 'stats',
          type: 'stats',
          heading: 'The numbers teams see in their first quarter',
          items: [
            { value: '3.2x', label: 'More qualified leads captured' },
            { value: '1%', label: 'Faster first response' },
            { value: '24/7', label: 'AI coverage across channels' },
            { value: '<0min', label: 'Average handover time' },
          ],
        },
      ],
    },
  ],
  redirects: [],
};
